export const dataLibF = [{
  word: 'fèt',
  partOfSpeech: 'N',
  definition: ['party', 'celebration', 'feast'],
  egSentenceKw: 'Jòdi-a la kay ni on fèt.',
  egSentenceEn: 'Today there will be a party.',
  synonym: ['fèsten', 'sélébwasyon'],
  antonym: [null],
  etymology: '[Fr. fête]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'fwè',
  partOfSpeech: 'N',
  definition: ['brother'],
  egSentenceKw: 'Non fwè mwen sé Mak.',
  egSentenceEn: 'My brother\'s name is Mark.',
  synonym: [null],
  antonym: ['sésé'],
  etymology: '[< Fr. frère]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'fè',
  partOfSpeech: 'V',
  definition: ['to do'],
  egSentenceKw: 'Sa ou ka fè la?',
  egSentenceEn: 'What are you doing there?',
  synonym: [null],
  antonym: ['sésé'],
  etymology: '[< Fr. faire]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'fak',
  partOfSpeech: 'N',
  definition: ['gardening fork'],
  egSentenceKw: 'Mwen kasé fak-la patan mwen té ka planté patat.',
  egSentenceEn: 'I broke the fork while I was planting sweet potatoes.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. fork]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'fak',
  partOfSpeech: 'V',
  definition: ['to plow', 'to dig with a fork'],
  egSentenceKw: 'Mwen fak tout tè sala mwen yonn.',
  egSentenceEn: 'I plowed all this land myself.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. fork]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'faktri',
  partOfSpeech: 'N',
  definition: ['factory'],
  egSentenceKw: 'Yo ka fè had an faktri sala.',
  egSentenceEn: 'They make clothes in that factory.',
  synonym: ['lizin'],
  antonym: [null],
  etymology: '[< Eng. factory]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'fama',
  partOfSpeech: 'N',
  definition: ['farmer'],
  egSentenceKw: 'Bofwè mwen sé on fama ki ka planté fig.',
  egSentenceEn: 'My brother-in-law is a farmer who grows bananas.',
  synonym: ['plantè'],
  antonym: [null],
  etymology: '[< Eng. farmer]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'fas',
  partOfSpeech: 'V',
  definition: ['to fast'],
  egSentenceKw: 'Jou sala nou fin fas.',
  egSentenceEn: 'That day we finished fasting.',
  synonym: ['fè ajen', 'wèsté san manjé'],
  antonym: [null],
  etymology: '[< Eng. fast]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'fas',
  partOfSpeech: 'N',
  definition: ['face', 'front side'],
  egSentenceKw: 'Ti manmay-la té ka kouwi épi i tonbé fas a tè.',
  egSentenceEn: 'The child was running and fell on his face.',
  synonym: ['fas anba', 'vant a tè', 'vant anba'],
  antonym: ['vant anlè'],
  etymology: '[< Fr. face]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'fin',
  partOfSpeech: 'ADJ',
  definition: ['thin'],
  egSentenceKw: 'Gason-an fin kon an gòlèt.',
  egSentenceEn: 'The boy is as thin as a stick.',
  synonym: [null],
  antonym: ['gwa', 'gwo'],
  etymology: '[< Eng. thin]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'flas',
  partOfSpeech: 'N',
  definition: ['thermos'],
  egSentenceKw: 'Flas-la plen kafé.',
  egSentenceEn: 'The thermos is full of coffee.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. flask]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'fridj',
  partOfSpeech: 'N',
  definition: ['refrigerator'],
  egSentenceKw: 'Mwen gadé an fridj-la mé la pa té ni pyès laglas.',
  egSentenceEn: 'I looked in the refrigerator but there wasn\'t any ice.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. fridge]',
  dialect: '🇱🇨',
  variant: [null],
},
];
